export const nav = {
  home: 'Home',
  webHosting: 'Web Hosting',
  gameHosting: 'Game Servers',
  vps: 'VPS Hosting',
  dedicated: 'Dedicated Servers',
  businessSolutions: 'Business Solutions',
  network: 'SynthoNetwork',
  colocation: 'Colocation',
  ipTransit: 'IP Transit',
  contact: 'Contact Us',
  clientArea: 'Client Area',
  services: 'Services',
  support: 'Support',
  faq: 'FAQ',
  abuse: 'Report Abuse'
};